import React from 'react';
import classNames from 'classnames';
import Cleave from 'cleave.js/react';

export default function CardExpiry({
	id: initialId,
	name,
	label,
	isRequired,
	placeholder,
	errorMessage = false,
	disabled,
	autoComplete = 'cc-exp',

	// controlled
	value,
	onChange,
}) {
	const id = initialId || `field--${name}`;

	const placeholderToDisplay = isRequired ? (placeholder || label) + '*' : placeholder || label;

	const hasError =
		(typeof errorMessage === 'boolean' && errorMessage === true) || errorMessage.length > 0;

	return (
		<div className="TextInput formElement formElement-text ValidatedForm-Field">
			<Cleave
				name={name}
				id={id || name}
				className={classNames('TextInput-field formElement-field ty-b2', {
					'formElement-field--filled': value,
					'formElement-field--invalid': hasError,
				})}
				type="tel"
				placeholder={placeholderToDisplay}
				required={isRequired}
				options={{ date: true, datePattern: ['m', 'y'] }}
				maxLength={5}
				minLength={5}
				pattern={'^(0[1-9]|1[0-2])/?([0-9]{2})$'}
				value={value}
				onChange={onChange}
				disabled={disabled}
				autoComplete={autoComplete}
			/>
			{label && (
				<label className="formElement-label ty-c4" htmlFor={id || name}>
					{isRequired ? label + '*' : label}
				</label>
			)}
			{errorMessage && (
				<span className="formElement-message" role="alert">
					{errorMessage}
				</span>
			)}
		</div>
	);
}
